import React from 'react'
import './sidebar.css';

export const Sidebar = () => {
    return (
        <div>
            <div className="right-head">Related Questions</div>
                <hr />
                <div className="right-body">Did you ever get a request for a favor from a relative who never showed any respect or</div>
                <div className="right-body">What did someone say to you that instantly made you realize their life was in danger?</div>
                <div className="right-body">Have you ever lost any respect for someone instantly?</div>
                <div className="right-body">What made you respect someone today?</div>
                <div className="right-body">Who has totally lost your respect? Why?</div>
                <div className="right-body">How can you make others respect you?</div>

                <div className="right-footer">Ask a question</div>
        </div>
    )
}
